




















































































































































import Vue from 'vue'
import {
  defaultPosterImage,
  userAvatarImage,
  INSTRUCTOR_NAME_MAX_LENGTH
} from '../../helper/constants'
import { getMobileTheme } from '../../helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: {
    BaseIcon
  },
  props: {
    productId: String,
    productTitle: String,
    posterImage: String,
    productDescription: String,
    instructorName: String,
    instructorHeadshot: String,
    activeProduct: String,
    upsellProduct: {
      type: Boolean,
      default: false
    },
    sliderCard: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      userAvatarImage,
      defaultPosterImage,
      instructorNameLimit: INSTRUCTOR_NAME_MAX_LENGTH
    }
  },
  computed: {
    newMobileScreens() {
      return this.$store.getters.newMobileScreens
    }
  },
  filters: {
    truncateText(text: string, MAX_LENGTH = 25): string {
      if (text.length <= MAX_LENGTH) return text

      return text.slice(0, MAX_LENGTH) + '...'
    }
  },
  methods: {
    getMobileTheme
  }
})
